/* Setup gate — single source of truth for the "pending_setup_wizard" flag.
 *
 * A brand-new signup goes: verify email → create workspace → setup wizard →
 * Stripe checkout. Any component with a checkout/hard-gate effect
 * (BillingSettings auto-checkout, TrialGateBanner hard-gate, future gates)
 * MUST call isSetupGateActive() and stand down while it returns true —
 * otherwise it races the wizard navigation and yanks the user off mid-setup
 * (the iter327/328 signup bug).
 *
 * Lifecycle:
 *   deferGatingForSetup()  — AppLayout.handleCreateWorkspace, right before create
 *   isSetupGateActive()    — every gating effect, as an early-return guard
 *   clearSetupGate()       — WorkspaceSetupWizard on apply/skip completion
 *
 * sessionStorage-backed, so an abandoned tab never leaves a stale flag.
 */
const KEY = 'pending_setup_wizard';

export function deferGatingForSetup() {
  try { window.sessionStorage.setItem(KEY, '1'); } catch { /* ignore */ }
}

export function clearSetupGate() {
  try { window.sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function isSetupGateActive() {
  try { return Boolean(window.sessionStorage.getItem(KEY)); } catch { return false; }
}
